import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { NAME_REDUCER } from './constants';
import { IState } from './types/reducer';

const initialState: IState = {
  shopInfo: null,
  staffs: [],
  staffsBookingOnline: [],
  categories: [],
  socialMedia: [],
  quickBookingService: [],
  allSetting: null,
  allShopSetting: null,
  settingDepositBooking: null,
  notification: null,
  servicesByCategory: [],
  servicesByCategoryLoading: true,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.get.servicesByCategory.fetch, (state) => {
        state.servicesByCategoryLoading = true;
      })
      .addCase(actions.get.servicesByCategory.success, (state, { payload }) => {
        state.servicesByCategory = payload;
        state.servicesByCategoryLoading = false;
      })
      .addCase(actions.get.servicesByCategory.fail, (state) => {
        state.servicesByCategoryLoading = false;
      })
      .addCase(actions.get.settingDepositBooking.fetch, (state) => {
        state.settingDepositBooking = null;
      })
      .addCase(actions.get.settingDepositBooking.success, (state, { payload }) => {
        state.settingDepositBooking = payload;
      })
      .addCase(actions.get.staffsBookingOnlineWithCustomer, (state) => {
        state.staffsBookingOnline = [];
      })
      .addCase(actions.get.allSetting.success, (state, { payload }) => {
        state.allSetting = payload;
      })
      .addCase(actions.get.quickServices.success, (state, { payload }) => {
        state.quickBookingService = payload;
      })
      .addCase(actions.get.socialMedia.success, (state, { payload }) => {
        state.socialMedia = payload;
      })
      .addCase(actions.get.categories.success, (state, { payload }) => {
        state.categories = payload;
      })
      .addCase(actions.get.staffs.success, (state, { payload }) => {
        state.staffs = payload;
      })
      .addCase(actions.get.staffsBookingOnline.success, (state, { payload }) => {
        state.staffsBookingOnline = payload;
      })
      .addCase(actions.getShopInfo.success, (state, { payload }) => {
        state.shopInfo = payload;
      })
      .addCase(actions.get.allShopSetting.success, (state, { payload }) => {
        state.allShopSetting = payload;
      })
      .addCase(actions.get.notification.success, (state, { payload }) => {
        state.notification = payload;
      })
      ;
  },
});

const shopServiceReducer = Slice.reducer;
export default shopServiceReducer;
